export interface ImageComponentInterface {
	background: string,
}

export class ImageComponentClass implements ImageComponentInterface {
	background = '';
}
